import React from 'react';
import Icon from '3-components/Icon/Icon';
import { ClickOrPressEvent } from 'types/mouseEvents';

export interface LinkProps {
    href: string;
    linkText: string;
    target?: string;
    linkSkin?: number;
    linkSize?: string;
    isDisabled?: boolean;
    linkCustomClass?: string;
    prefixIcon?: string;
    suffixIcon?: string;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
}

const Link = ({ href, linkText, target, linkSkin, linkSize, isDisabled, linkCustomClass, suffixIcon, prefixIcon, onClick }: LinkProps) => {
    const linkClasses = `${linkSkin ? `link-skin-${linkSkin}` : 'link-skin-1'}${linkSize ? ` link-size-${linkSize}` : ' link-size-md'}${isDisabled ? 'link-disabled' : ''}${linkCustomClass}${prefixIcon || suffixIcon ? 'link-has-icons' : ''}`;

    return (
        <a href={href} target={target ? target : ''} className={linkClasses} onClick={onClick}>
            {prefixIcon && <Icon icon={prefixIcon} />}
            <span className="link-text">{linkText}</span>
            {suffixIcon && <Icon icon={suffixIcon} />}
        </a>
    );
};

export default Link;
